module.exports = __webpack_public_path__ + "static/media/cookedegg.069080ef.webp";